// @flow
import * as React from 'react';

import type { FlyoutTriggerAttributes } from 'reshaped';

import { useEntityPermissions } from '@gandi/acl';
import { Button, type ButtonProps } from '@gandi/reshaped';
import { useTranslator } from '@gandi/translate';

import { ButtonTooltip } from 'src/Reshaped/ButtonTooltip';
import { useOrganization } from 'src/hooks/useOrganization';
import { ORGA_WRITE } from 'src/modules/permissions';

type CustomButtonProps = {
  ...ButtonProps,
  attributes?: FlyoutTriggerAttributes,
};

function CustomButton({ attributes, ...props }: CustomButtonProps) {
  const { __ } = useTranslator();

  return (
    <Button
      size="large"
      variant="outline"
      // $FlowFixMe[incompatible-type-arg]
      // $FlowFixMe[incompatible-type]
      attributes={{ style: { flex: 1 }, ...attributes }}
      {...props}
    >
      {__('Edit')}
    </Button>
  );
}

type Props = {
  value: string,
  handleEdit: (value: string) => void | Promise<void>,
  disabled: boolean,
};

export function EditButton({
  handleEdit,
  value,
  disabled,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const { hasPermissions, isLoadedPermissions, isFetchingPermissions } =
    useEntityPermissions(value);
  const hasEnoughPersmission = hasPermissions([ORGA_WRITE]);

  const { isLoadedOrganization, isFetchingOrganization } =
    useOrganization(value);

  return (
    <ButtonTooltip
      as={CustomButton}
      disabled={
        disabled ||
        !isLoadedPermissions ||
        !isLoadedOrganization ||
        !hasEnoughPersmission
      }
      tooltipText={
        !hasEnoughPersmission &&
        __('You do not have sufficient permissions to edit this organization')
      }
      onClick={() => handleEdit(value)}
      loading={isFetchingPermissions || isFetchingOrganization}
    />
  );
}
